export default [
  {
    name: 'confirmar-acesso-externo',
    path: '/portal-cliente/confirmar-acesso',
    component: () => import('@/app-modulo/documento/confirmar-acesso-externo/ConfirmarAcessoExterno.vue'),
    meta: {
      requiredAuth: false,
      layout: 'full',
    },
  },
]
